import React from 'react';
import styled, { css } from 'styled-components';

const TableContainerOuter: React.FCC = ({ children }) => (
  <Container>{children}</Container>
);

const Container = styled.div<{}>(
  ({ theme }) => css`
    padding: 0 ${theme.space('xxs')};
    background-color: ${theme.color('white')};
    border-radius: ${theme.getTokens().border.radius.base};
  `,
);
export default TableContainerOuter;
